import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Sprout, Truck, ShoppingBag, HeartHandshake } from "lucide-react";

const ROLES = [
  {
    icon: Sprout,
    title: "Farm Sourcing Associate",
    location: "Bhadra, Rajasthan · Full-time",
    copy: "Visit partner farms, quality-check harvests, and bring back the best of every batch.",
  },
  {
    icon: Truck,
    title: "Delivery Partner",
    location: "Hanumangarh, Sri Ganganagar · Full-time",
    copy: "Ride our cold-chain van, deliver farm-fresh boxes on time, and be the face of the brand.",
  },
  {
    icon: ShoppingBag,
    title: "Order Packer",
    location: "Malkash HQ · Full-time",
    copy: "Pack every order like it's going to your own family. Careful, quick, and clean.",
  },
  {
    icon: HeartHandshake,
    title: "Customer Care (Bilingual)",
    location: "Remote / Malkash · Full or Part-time",
    copy: "Answer WhatsApp, phone and email in Hindi and English. Warm, patient, honest.",
  },
];

export const Careers = ({ open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        data-testid="careers-dialog"
        className="max-w-3xl max-h-[85vh] overflow-y-auto bg-background"
      >
        <DialogHeader>
          <div className="font-mono-ui text-[10px] uppercase tracking-widest text-accent mb-2">
            Village Farm Food — Careers
          </div>
          <DialogTitle className="font-display text-3xl md:text-4xl font-semibold leading-tight">
            Work with us
          </DialogTitle>
          <p className="mt-3 text-sm text-muted-foreground max-w-xl">
            Small team, big values. We hire from villages first, pay honest wages,
            and treat every job as important. If you love food and farms — read on.
          </p>
        </DialogHeader>

        <div className="mt-5 grid sm:grid-cols-2 gap-4">
          {ROLES.map((r) => (
            <div
              key={r.title}
              data-testid={`career-role-${r.title.replace(/\s+/g, "-").toLowerCase()}`}
              className="rounded-xl border border-border p-5 hover-lift bg-card"
            >
              <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center">
                <r.icon className="w-5 h-5 text-accent-foreground" />
              </div>
              <div className="mt-4 font-display text-lg font-semibold leading-tight">
                {r.title}
              </div>
              <div className="mt-1 font-mono-ui text-[10px] uppercase tracking-widest text-muted-foreground">
                {r.location}
              </div>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
                {r.copy}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-6 rounded-xl bg-secondary/60 p-5">
          <div className="font-display text-lg font-semibold">How to apply</div>
          <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
            WhatsApp your name, village, role you're applying for, and 2 lines
            about yourself to{" "}
            <a href="tel:+919397363140" className="text-accent underline underline-offset-2 font-medium">
              +91 93973 63140
            </a>{" "}
            or email{" "}
            <a href="mailto:hello@villagefarmfood.com" className="text-accent underline underline-offset-2 font-medium">
              hello@villagefarmfood.com
            </a>
            . We reply within 3 days.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
